import { render, staticRenderFns } from "./ReportCategoryCard.vue?vue&type=template&id=44c8cba8&scoped=true&"
import script from "./ReportCategoryCard.vue?vue&type=script&lang=js&"
export * from "./ReportCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportCategoryCard.vue?vue&type=style&index=0&id=44c8cba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8cba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
